/* eslint-disable  */
//@ts-nocheck

import React from 'react';

import * as enums from '@playbook-technologies/common-enums';

class ExerciseEditHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.toggleMinimize = this.toggleMinimize.bind(this);
  }
  toggleMinimize(ev) {
    if (this.props.minimizeDisabled) return;
    // do not toggle on delete, move up or move down actions (which are SPAN, I)
    if (ev.target.tagName === 'DIV') this.props.onToggleMinimize();
  }
  render() {
    //console.log('got to render?');
    let index = null;
    if (this.props.index) {
      index = <div className="index">{this.props.index}</div>;
    }
    let buttonMoveUp = null;
    if (this.props.id > 0) {
      buttonMoveUp = (
        <span
          className="actionLink moveUp"
          onClick={() => this.props.onMoveUp(this.props.id)}
        >
          <i className="icon-arrow-up"></i>
        </span>
      );
    }
    let buttonMoveDown = null;
    if (this.props.id < this.props.exerciseLength - 1) {
      buttonMoveDown = (
        <span
          className="actionLink moveDown"
          onClick={() => this.props.onMoveDown(this.props.id)}
        >
          <i className="icon-arrow-down"></i>
        </span>
      );
    }
    let buttonDelete = null;
    if (!this.props.deleteDisabled) {
      buttonDelete = (
        <span
          className="actionLink delete"
          onClick={() => this.props.onDelete(this.props.id)}
        >
          <i className="icon-remove"></i>
        </span>
      );
    }
    let title = this.props.data ? this.props.data.name : null;
    if (!title) {
      if (this.props.data.type === enums.Exercise.Type.Product.value) {
        title = 'Define product';
      } else if (this.props.data.type === enums.Exercise.Type.Nutrition.value) {
        title = 'Define nutrition';
      } else if (this.props.data.type === enums.Exercise.Type.Single.value) {
        title = 'Define exercise';
      } else if (this.props.data.type === enums.Exercise.Type.Multiple.value) {
        title = 'Define circuit';
      } else {
        title = 'Define video';
      }
    }
    //console.log('ready to render?', this.props.data);

    return (
      <div className="exerciseHeader" onClick={this.toggleMinimize}>
        {index}
        <div className="title">{title}</div>
        {buttonMoveUp}
        {buttonMoveDown}
        {buttonDelete}
      </div>
    );
  }
}

export default ExerciseEditHeader;
